import clsx from 'clsx'

export const IconColor = {
  PRIMARY: 'primary',
  HOVER: 'hover',
  ACTIVE: 'active',
  SECONDARY: 'secondary',
  SECONDARY_HOVER: 'secondary-hover',
  SECONDARY_ACTIVE: 'secondary-active',
  DISABLED: 'disabled',
  INFO: 'info',
  INFO_DARK: 'info-dark',
  SUCCESS: 'success',
  SUCCESS_ON_BG_FILL: 'success-on-bg-fill',
  CAUTION: 'caution',
  WARNING: 'warning',
  WARNING_ON_BG_FILL: 'warning-on-bg-fill',
  CRITICAL: 'critical',
  CRITICAL_ON_BG_FILL: 'critical-on-bg-fill',
  EMPHASIS: 'emphasis',
  EMPHASIS_HOVER: 'emphasis-hover',
  EMPHASIS_ACTIVE: 'emphasis-active',
  CRITICAL_HOVER: 'critical-hover',
  CRITICAL_ACTIVE: 'critical-active',
  DISABLE_ACTIVE: 'disabled-active',
  DISABLE_HOVER: 'disabled-hover',
  ASSIST: 'assist',
  BRAND: 'brand',
  ON_COLOR: 'on-color',
  TRANSPARENT: 'transparent',
  LINK: 'link',
  PURPLE: 'purple',
  SKY: 'sky',
  GREEN: 'green',
  YELLOW: 'yellow',
  ORANGE: 'orange',
  KAKI: 'kaki',
  SORA: 'sora',
  SUMI: 'sumi',
  BENI: 'beni'
} as const
export type IconColor = (typeof IconColor)[keyof typeof IconColor]

const colorClass = (color: IconColor | string) => {
  switch (color) {
    case IconColor.PRIMARY:
      return 'fill-primary'
    case IconColor.HOVER:
      return 'fill-hover'
    case IconColor.ACTIVE:
      return 'fill-active'
    case IconColor.SECONDARY:
      return 'fill-secondary'
    case IconColor.SECONDARY_HOVER:
      return 'fill-secondary-hover'
    case IconColor.SECONDARY_ACTIVE:
      return 'fill-secondary-active'
    case IconColor.DISABLED:
      return 'fill-disabled'
    case IconColor.INFO:
      return 'fill-info'
    case IconColor.INFO_DARK:
      return 'fill-info-dark'
    case IconColor.SUCCESS:
      return 'fill-success'
    case IconColor.SUCCESS_ON_BG_FILL:
      return 'fill-success-on-bg-fill'
    case IconColor.CAUTION:
      return 'fill-caution'
    case IconColor.WARNING:
      return 'fill-warning'
    case IconColor.WARNING_ON_BG_FILL:
      return 'fill-warning-on-bg-fill'
    case IconColor.CRITICAL:
      return 'fill-critical'
    case IconColor.CRITICAL_ON_BG_FILL:
      return 'fill-critical-on-bg-fill'
    case IconColor.EMPHASIS:
      return 'fill-emphasis'
    case IconColor.EMPHASIS_HOVER:
      return 'fill-emphasis-hover'
    case IconColor.EMPHASIS_ACTIVE:
      return 'fill-emphasis-active'
    case IconColor.CRITICAL_HOVER:
      return 'fill-critical-hover'
    case IconColor.CRITICAL_ACTIVE:
      return 'fill-critical-active'
    case IconColor.DISABLE_ACTIVE:
      return 'fill-disabled-active'
    case IconColor.DISABLE_HOVER:
      return 'fill-disabled-hover'
    case IconColor.ASSIST:
      return 'fill-assist'
    case IconColor.BRAND:
      return 'fill-brand'
    case IconColor.ON_COLOR:
      return 'fill-on-color'
    case IconColor.TRANSPARENT:
      return 'fill-transparent'
    case IconColor.LINK:
      return 'fill-link'
    case IconColor.PURPLE:
      return 'fill-purple'
    case IconColor.SKY:
      return 'fill-sky'
    case IconColor.GREEN:
      return 'fill-green'
    case IconColor.YELLOW:
      return 'fill-yellow'
    case IconColor.ORANGE:
      return 'fill-orange'
    case IconColor.KAKI:
      return 'fill-sora'
    case IconColor.SORA:
      return 'fill-kaki'
    case IconColor.SUMI:
      return 'fill-sumi'
    case IconColor.BENI:
      return 'fill-beni'
    // default:
    //   if (color.startsWith('#')) {
    //     return `style="fill: ${color}"`
    //   }
    //   return color
  }
}

export const IconType = {
  HOME: 'home',
  INBOX: 'inbox',
  PRODUCT: 'product',
  USER: 'user',
  SETTING: 'setting',
  ASSIST: 'assist',
  MEMBER: 'member',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  RADIO_BUTTON: 'radiobutton',
  DATE_TIME: 'datetime',
  ADD: 'add',
  VISIBILITY: 'visibility',
  VISIBILITY_OFF: 'visibilityoff',
  SEARCH: 'search',
  CHECK: 'check',
  PLUS: 'plus',
  MINUS: 'minus',
  DRAG: 'drag',
  PULL_DOWN: 'pulldown',
  UP: 'arw-up',
  DOWN: 'arw-down',
  RIGHT: 'arw-right',
  LEFT: 'arw-left',
  NEW_TAB: 'new-tab',
  LOADING: 'loading',
  DOWNLOAD: 'download',
  DELETE: 'delete',
  IMAGE: 'image',
  HELP: 'help',
  OTHER: 'other',
  CLOSE: 'close',
  CLOSE_SUB: 'close-sub',
  MEMO: 'memo',
  EDIT: 'edit',
  HISTORY: 'history',
  VIEW_SET: 'view-set',
  DESCENDING: 'descending',
  ASCENDING: 'ascending',
  ARROW_BACK: 'arw-back',
  TAG: 'tag',
  HASH: 'hash',
  CLOCK: 'clock',
  GROUP: 'group',
  FILE: 'file',
  FM_BOLD: 'fm-bold',
  FM_ITALIC: 'fm-italic',
  FM_UNDERLINE: 'fm-underline',
  FM_ALIGN_LEFT: 'fm-alignleft',
  FM_ALIGN_CENTER: 'fm-aligncenter',
  FM_ALIGN_RIGHT: 'fm-alignright',
  FM_INDENT: 'fm-indent',
  FM_LINK: 'fm-link',
  FM_LIST: 'fm-list',
  FM_NUMBER: 'fm-number',
  FM_TABLE: 'fm-table',
  CODE: 'code',
  COPY: 'copy',
  ARROW_FORWARD: 'arw-forward',
  MOVE_RIGHT: 'move-right',
  CART: 'cart',
  APP: 'app',
  DOMAIN: 'domain',
  LOCATION: 'location',
  PAYMENT: 'payment',
  STORE: 'store',
  TRUCK: 'truck',
  WAREHOUSE: 'warehouse',
  GIFT: 'gift',
  PAGE_FIRST: 'page-first',
  PAGE_LAST: 'page-last',
  INCREASE: 'increase',
  DECREASE: 'decrease',
  REDUCTION: 'reduction',
  EXPANSION: 'expansion',
  ZOOM_IN: 'zoom-in',
  ZOOM_OUT: 'zoom-out',
  ROTATE_CW: 'rotate-cw',
  ROTATE_CCW: 'rotate-ccw',
  PROFIT: 'profit',
  POINT: 'point',
  CHANNEL: 'channel',
  CONTACT: 'contact',
  ANALYTICS: 'analytics',
  MARKETING: 'marketing',
  SYSTEM: 'system',
  ACCOUNT: 'account',
  IMAGE_ADD: 'image-add',
  RECEIPT: 'receipt',
  CALCULATOR: 'calculator',
  MAIL: 'mail',
  WALLET: 'wallet',
  LOGIN: 'login',
  BEGINNER: 'beginner',
  REPEAT: 'repeat',
  ROYAL: 'royal',
  ALL_USERS: 'all-users',
  OPENED_MAIL: 'opened-mail',
  CLICK: 'click',
  WITHDRAWAL: 'withdrawal',
  BED: 'bed',
  SEND: 'send',
  RANKING_YELLOW: 'ranking-yellow',
  RANKING_PINK: 'ranking-pink',
  ARTICLE: 'article',
  TRENDING_UP: 'trending-up',
  ZAP: 'zap',
  // smarthub
  ALERT: 'alert',
  ARROW_DOWN: 'arrow-down',
  ARROW_RIGHT: 'arrow-right',
  ARROW_UNDO: 'arrow-undo',
  ARROWS_ASC: 'arrows-asc',
  ARROWS_DESC: 'arrows-desc',
  ARROWS_UP_DOWN: 'arrows-up-down',
  BELL: 'bell',
  BUILDING: 'building',
  CHART_COLUMN: 'chart-column',
  CHART_LINE: 'chart-line',
  CONTENTS: 'contents',
  DASHBOARD: 'dashboard',
  DATABASE: 'database',
  ELLIPSIS: 'ellipsis',
  HEADSET: 'headset',
  LIST: 'list',
  LOG_OUT: 'log-out',
  PREVIEW: 'preview',
  RECOMMEND: 'recommend',
  REVIEW_HEART: 'review-heart',
  SEO: 'seo',
  SETTINGS: 'settings',
  TRASH: 'trash',
  USER_KEY: 'user-key',
  USER_SQUARE: 'user-square',
  WEB_PAGE: 'web-page',
  WRITING: 'writing',
  AI_FILL: 'ai-fill',
  CROWN: 'crown',
  REFRESH: 'refresh',
  CIRCLE_CHECK: 'circle-check',
  CODE_SQUARE: 'code-square',
  COPY_PLUS: 'copy-plus',
  DOOR: 'door',
  MOUSE_POINTER: 'mouse-pointer',
  SEARCH_TITLE: 'search-title'
} as const
export type IconType = (typeof IconType)[keyof typeof IconType]

export const IconInversion = {
  DEFAULT: 'DEFAULT',
  HORIZON: 'HORIZON',
  VERTICAL: 'VERTICAL'
} as const
export type IconInversion = (typeof IconInversion)[keyof typeof IconInversion]

export const IconRotate = {
  RIGHT: 'RIGHT',
  LEFT: 'LEFT'
} as const
export type IconRotate = (typeof IconRotate)[keyof typeof IconRotate]

export interface IconProps {
  color?: IconColor
  hoverColor?: IconColor
  activeColor?: IconColor
  size?: 12 | 16 | 20 | 24 | 40 | 64
  type: IconType
  inversion?: IconInversion
  rotate?: IconRotate
  spin?: boolean
  line?: boolean
  roundBorder?: boolean
}

const iconSizeClass = (size: number) => {
  switch (size) {
    case 12:
      return 'h-3 w-3 min-h-3 min-w-3'
    case 16:
      return 'h-4 w-4 min-h-4 min-w-4'
    case 20:
      return 'h-5 w-5 min-h-5 min-w-5'
    case 24:
      return 'h-6 w-6 min-h-6 min-w-6'
    case 40:
      return 'h-10 w-10 min-h-10 min-w-10'
    case 64:
      return 'h-16 w-16 min-h-16 min-w-16'
    default:
      return `h-${size / 4} w-${size / 4}`
  }
}

const Icon = ({
  color = IconColor.PRIMARY,
  hoverColor = color,
  activeColor = color,
  size = 16,
  type,
  inversion,
  rotate,
  line = false,
  roundBorder = false
}: IconProps) => {
  const icon = line ? `${type}_line` : type
  return (
    <>
      <svg
        className={clsx(
          'inline-block',
          colorClass(color),
          `group-hover:${colorClass(hoverColor)}`,
          `group-active:${colorClass(activeColor)}`,
          iconSizeClass(size),
          rotate == IconRotate.RIGHT && 'rotate-90',
          rotate == IconRotate.LEFT && '-rotate-90',
          inversion == IconInversion.HORIZON && '-scale-x-100',
          inversion == IconInversion.VERTICAL && '-scale-y-100',
          type == IconType.LOADING && 'animate-spin',
          roundBorder && 'border-surface flex-none rounded-full border-2'
        )}
      >
        <use xlinkHref={`/assets/icons.svg#${icon}`}></use>
      </svg>
    </>
  )
}
export default Icon
